import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export const PageBackButton = () => {
  const { pathname } = useLocation(), navigate = useNavigate();
  // These pages have a left-aligned back action with their own save/navigation logic.
  if (/^\/ctn\/bestellingen\/[^/]+(?:\/bewerken)?\/?$/.test(pathname) || pathname === "/uren-invoer") return null;
  return <div className="flex justify-start mb-4" data-testid="page-back-container"><Button type="button" variant="ghost" className="min-h-10 -ml-2" onClick={() => window.history.state?.idx > 0 ? navigate(-1) : navigate("/")} disabled={pathname === "/"} data-testid="page-back-button"><ArrowLeft size={18} className="mr-2" />Terug</Button></div>;
};